import { QueueApi } from 'api/QueueApi';
import { backendApiClient } from 'container/backendApiClient';

export const queueApi = new QueueApi(backendApiClient);
